import brandColors from '../colors/brandColors';

const lightTheme = {
  colors: {
    ...brandColors,
    background: brandColors.gray[500],
    text: brandColors.gray[800],
    black: brandColors.gray[900],
    white: brandColors.gray[0],
  },
  fonts: {
    headings: 'Poppins',
    body: 'Poppins',
    monospace: 'Consolas, Courier New, monospace, monospace',
  },
};

export default lightTheme;
